import type { PackageStatus } from '@/features/package/domain/enums/PackageStatus'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class LivePackageFilterEntity {
  regions?: Array<RegionMiniEntity>
  packageStatuses?: Array<PackageStatus>
  fetchAll?: boolean
  fromDate?: string
  toDate?: string
  limit?: number
  cursor?: string
  referenceCode?: string
  trackingPanelUser?: { trackingPanelUserId: string; trackingPanelUserDisplayName: string }
}
